import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyUserGroupAll,
  getMyUserGroupPage,
  getMyBusinessPage,
  getMyMaintainPage
} from '@/api/annexfileinfoserv'

export default {
  state: {
    state_AnnexFileInfo_AddObjResult: null,
    state_AnnexFileInfo_GetAllResult: null,
    state_AnnexFileInfo_GetPageResult: null,
    state_AnnexFileInfo_GetDetailResult: null,
    state_AnnexFileInfo_ModifyObjResult: null,
    state_AnnexFileInfo_DeleteObjResult: null,
    state_AnnexFileInfo_GetMyUserGroupAllResult: null,
    state_AnnexFileInfo_GetMyUserGroupPageResult: null,
    state_AnnexFileInfo_GetMyBusinessPageResult: null,
    state_AnnexFileInfo_GetMyMaintainPageResult: null
  },
  mutations: {
    SET_ANNEXFILEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_AddObjResult = rst
    },
    SET_ANNEXFILEINFO_GETALL_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetAllResult = rst
    },
    SET_ANNEXFILEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetPageResult = rst
    },
    SET_ANNEXFILEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetDetailResult = rst
    },
    SET_ANNEXFILEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_ModifyObjResult = rst
    },
    SET_ANNEXFILEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_DeleteObjResult = rst
    },
    SET_ANNEXFILEINFO_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetMyUserGroupAllResult = rst
    },
    SET_ANNEXFILEINFO_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetMyUserGroupPageResult = rst
    },
    SET_ANNEXFILEINFO_GETMYBUSINESSPAGE_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetMyBusinessPageResult = rst
    },
    SET_ANNEXFILEINFO_GETMYMAINTAINPAGE_RESULT: (state, rst) => {
      state.state_AnnexFileInfo_GetMyMaintainPageResult = rst
    }
  },
  actions: {
    AnnexFileInfoServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetMyBusinessPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyBusinessPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETMYBUSINESSPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETMYBUSINESSPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    AnnexFileInfoServ_GetMyMaintainPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyMaintainPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_ANNEXFILEINFO_GETMYMAINTAINPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_ANNEXFILEINFO_GETMYMAINTAINPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_AnnexFileInfo_AddObjResult: state => {
      return state.state_AnnexFileInfo_AddObjResult
    },
    get_AnnexFileInfo_GetAllResult: state => {
      return state.state_AnnexFileInfo_GetAllResult
    },
    get_AnnexFileInfo_GetPageResult: state => {
      return state.state_AnnexFileInfo_GetPageResult
    },
    get_AnnexFileInfo_GetDetailResult: state => {
      return state.state_AnnexFileInfo_GetDetailResult
    },
    get_AnnexFileInfo_ModifyObjResult: state => {
      return state.state_AnnexFileInfo_ModifyObjResult
    },
    get_AnnexFileInfo_DeleteObjResult: state => {
      return state.state_AnnexFileInfo_DeleteObjResult
    },
    get_AnnexFileInfo_GetMyUserGroupAllResult: state => {
      return state.state_AnnexFileInfo_GetMyUserGroupAllResult
    },
    get_AnnexFileInfo_GetMyUserGroupPageResult: state => {
      return state.state_AnnexFileInfo_GetMyUserGroupPageResult
    },
    get_AnnexFileInfo_GetMyBusinessPageResult: state => {
      return state.state_AnnexFileInfo_GetMyBusinessPageResult
    },
    get_AnnexFileInfo_GetMyMaintainPageResult: state => {
      return state.state_AnnexFileInfo_GetMyMaintainPageResult
    }
  }
}
